/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Shot_BoardInputs */

const en_mk_shot_board = /** @type {(inputs: Mk_Shot_BoardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KerjaBareng kanban board: Backlog, To do, In progress and In review columns, with issue cards some of which are assigned to agents.`)
};

const id_mk_shot_board = /** @type {(inputs: Mk_Shot_BoardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Papan kanban KerjaBareng: kolom Backlog, Akan dikerjakan, Dikerjakan, dan Perlu review, dengan kartu issue yang sebagian di-assign ke agen.`)
};

/**
* | output |
* | --- |
* | "KerjaBareng kanban board: Backlog, To do, In progress and In review columns, with issue cards some of which are assigned to agents." |
*
* @param {Mk_Shot_BoardInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_shot_board = /** @type {((inputs?: Mk_Shot_BoardInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Shot_BoardInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_shot_board(inputs)
	return en_mk_shot_board(inputs)
});